import { Link } from "react-router-dom";
import { businessConfig } from "@/config/business.config";

/**
 * Persistent mobile action bar, fixed to the viewport bottom below 900px:
 * three equal cells — Call · Text Photos · Get a Quote — on graphite.
 * `main` reserves bottom padding (global.css) so it never overlaps content.
 */
export function StickyMobileCta() {
  return (
    <div className="smc" data-sticky-cta>
      <a href={businessConfig.contact.phoneHref} className="smc__cell" aria-label={`Call ${businessConfig.identity.tradingName}`}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="var(--orange)" aria-hidden="true">
          <path d="M6.6 10.8a15 15 0 0 0 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1A17 17 0 0 1 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.3 1l-2.2 2.2Z" />
        </svg>
        Call
      </a>
      <a href={`mailto:${businessConfig.contact.email}`} className="smc__cell" aria-label="Email us">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--orange)" strokeWidth="2" aria-hidden="true">
          <rect x="3" y="5" width="18" height="14" />
          <path d="m3 6 9 7 9-7" />
        </svg>
        Email
      </a>
      <Link to="/contact" className="smc__cell smc__cell--orange">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" aria-hidden="true">
          <path d="M4 5h16v11H7l-3 3z" />
        </svg>
        Get a Quote
      </Link>

      <style>{`
        .smc {
          position: fixed; bottom: 0; left: 0; right: 0; z-index: 90;
          display: grid; grid-template-columns: 1fr 1fr 1fr;
          background: var(--graphite);
          box-shadow: 0 -6px 20px rgba(0,0,0,0.28);
          padding-bottom: env(safe-area-inset-bottom);
        }
        .smc__cell {
          display: flex; flex-direction: column; align-items: center; gap: 3px;
          padding: 10px 6px; color: #fff; text-decoration: none;
          font-family: var(--font-display); font-weight: 800; font-size: 12px;
          letter-spacing: 0.02em; text-transform: uppercase;
          border-right: 1px solid rgba(255,255,255,0.14);
        }
        .smc__cell:last-child { border-right: none; }
        .smc__cell--orange { background: var(--orange); }
        body.menu-open .smc { display: none; }
        @media (min-width: 900px) { .smc { display: none; } }
      `}</style>
    </div>
  );
}
